// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"078a2a6d","84":"c65e2868","85":"60ed23ba","152":"6b23ca67","153":"ff204805","317":"c62e3a0f","472":"c1d6dc44","492":"c0d20873","520":"01c0398f","703":"87a95d57","783":"086340e7","825":"5c122797","848":"9884dd9b","906":"2a962f2d","918":"1ec7730a"}[chunkId] + ".chunk.js";
};